import { pdpSharedNotifications } from '../PdpSharedNotifications/pdpSharedNotifications';

export const pdpRespNotifications = [...pdpSharedNotifications];
